import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import config from '@/config';

import { PageSeo } from '@/components';

// const BFS = dynamic(() => import('@/component/BFS.js'), { ssr: false });
const BFS = dynamic(() => import('../../components/BFS/BFS').then((mod) => mod.BFS), {
	ssr: false,
});
const Games = () => {
	const { t } = useTranslation('common');

	return (
		<>
			<PageSeo
				title={`Breadth First Search (BFS) - ${config.author}`}
				description={`Breadth First Search (BFS) algorithm - built using the React`}
				url={`${config.siteUrl}/games/bfs`}
			/>
			<BFS />
		</>
	);
};

export const getStaticProps = async ({ params, locale }) => {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common'])),
		},
		revalidate: 1,
	};
};

export default Games;
